module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-component"
  }, [_vm._l((_vm.components || []), function(component, index) {
    return [_c(_vm.getComponentName(component.name), {
      tag: "component",
      attrs: {
        "config": Object.keys(component.config || {}).length > 0 ? component.config : {},
        "emitEvents": _vm.getEmitEvents(component),
        "state": _vm.state,
        "eventBus": _vm.eventBus,
        "index": index,
        "column": _vm.column,
        "routeName": _vm.routeName,
        "row": _vm.row,
        "rowIndex": _vm.rowIndex,
        "embeddedModules": _vm.getEmbeddedModules(component),
        "columnIndex": _vm.columnIndex,
        "eventSourceService": _vm.eventSourceService,
        "eventManager": _vm.eventManager,
        "parentState": _vm.parentState,
        "parent": _vm.parent
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06874f6c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/GridComponentFactory.vue
// module id = 1226
// module chunks = 2